'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayerItem = exports.LayerGrid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2;
// import defaultsDeep from 'lodash/defaultsDeep';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropItem = require('../components/dnd/dropItem');

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 有点问题
var types = ['hc', 'custom', 'antd', 'material'];
// https://github.com/swagger-api/swagger-editor/blob/2cc957f755a72fcc005c084f689810ce468d2571/src/plugins/editor/components/editor.jsx

var LayerGrid = exports.LayerGrid = (_temp = _class = function (_React$PureComponent) {
  _inherits(LayerGrid, _React$PureComponent);

  function LayerGrid() {
    _classCallCheck(this, LayerGrid);

    return _possibleConstructorReturn(this, (LayerGrid.__proto__ || Object.getPrototypeOf(LayerGrid)).apply(this, arguments));
  }

  _createClass(LayerGrid, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className, style: this.props.style },
        this.props.children
      );
    }
  }]);

  return LayerGrid;
}(_react2.default.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.any,
  style: _propTypes2.default.object
}, _temp);


var __guid__ = 1;
function guid(prefix) {
  return prefix + __guid__++;
}
function wrapper(_ref) {
  var children = _ref.children;

  return children;
}
var LayerItem = exports.LayerItem = (_temp2 = _class2 = function (_React$PureComponent2) {
  _inherits(LayerItem, _React$PureComponent2);

  function LayerItem(props, context) {
    _classCallCheck(this, LayerItem);

    var _this2 = _possibleConstructorReturn(this, (LayerItem.__proto__ || Object.getPrototypeOf(LayerItem)).call(this, props));

    _this2.state = {
      active: false,
      guid: guid('layerItem')
    };
    context.layer.register(_this2.state.guid, function (active) {
      _this2.setState({
        active: active
      });
    });
    return _this2;
  }

  _createClass(LayerItem, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var layer = this.context.layer;
      var ItemWrapper = layer.isEditable() ? _dropItem.DropItem : wrapper;
      var _props = this.props,
          title = _props.title,
          children = _props.children,
          disabled = _props.disabled,
          onChange = _props.onChange,
          cardProps = _props.cardProps,
          menu = _props.menu;

      return _react2.default.createElement(
        _card2.default,
        _extends({
          className: 'j-editor-layerItem ' + (this.state.active ? 'active' : ''),
          onClick: function onClick() {
            layer.handleActive(_this3.state.guid);
          },
          style: this.props.style,
          title: title,
          extra: disabled || !layer.isEditable() ? null : menu
        }, cardProps),
        _react2.default.createElement(
          ItemWrapper,
          { types: types, doAction: function doAction(type, item) {
              var target = {
                id: _this3.state.guid,
                key: 'update',
                type: type,
                attrs: item.attrs
              };
              onChange && onChange(target);
            } },
          children
        )
      );
    }
  }]);

  return LayerItem;
}(_react2.default.PureComponent), _class2.contextTypes = {
  layer: _propTypes2.default.object
}, _class2.propTypes = {
  title: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.element,
  onChange: _propTypes2.default.func,
  cardProps: _propTypes2.default.object,
  style: _propTypes2.default.object,
  menu: _propTypes2.default.any
}, _class2.defaultProps = {
  cardProps: {}
}, _temp2);


//////////////////
// WEBPACK FOOTER
// ./src/layers/layerEditor.jsx
// module id = 48
// module chunks = 0